import sliceCreator from '../../index.jsx';
import {GET_ALL_DISTRICTS} from '../../../constants/index.jsx';
const _getAllDistrictsAction = sliceCreator('GET_ALL_DISTRICTS', GET_ALL_DISTRICTS, 'get');

const { asyncAction: getAllDistrictsAction, reducer, clearData: clearGetAllDistrictsAction } = _getAllDistrictsAction;

export default reducer;

export {
    getAllDistrictsAction,
    clearGetAllDistrictsAction
}